import * as propertyTypes from "../../property_types.js"
import { DataIsTemplateStringProperty, RightDrawerContainer, DataMenu, DataGridOptions } from "./common_app_metadata.js";

export class AppProject extends propertyTypes.Serializable {
    private additionalMetadata = new propertyTypes.ObjectPropertyExt("additional", "Additional")
        .addStateImplementation("default", Additional);
    public additional: Additional;

    private metadataAll: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.additionalMetadata.RenderInline = true;
        this.metadataAll = [this.additionalMetadata];
    };

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.metadataAll;
    }

}

class Additional extends propertyTypes.Serializable {

    private objectsMetadata = new propertyTypes.ObjectListPropertyExt("objects", "Additional objects", "name")
        .addStateImplementation("browserTitle", DataIsTemplateStringProperty)
        .addStateImplementation("pageTitle", DataIsTemplateStringProperty)
        .addStateImplementation("menuDataSource", DataMenu)
        .addStateImplementation("translations", DataTranslations)
        .addStateImplementation("rightDrawerContainer", RightDrawerContainer)
        .addStateImplementation("machinesGridOptions", DataGridOptions)
        .addStateImplementation("articleGridOptions", DataGridOptions)
        .addStateImplementation("projectContactsGridOptions", DataGridOptions)
        .addStateImplementation("addressContactsGridOptions", DataGridOptions)
        ;
    public objects: string;

    private additionalMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.objectsMetadata.IsReadOnly = true;
        this.additionalMetadata = [this.objectsMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.additionalMetadata;
    }
}

class DataTranslations extends propertyTypes.Serializable {
    private nameMetadata = new propertyTypes.TextProperty("name", "Name");
    public name: string;

    private dataMetadata = new propertyTypes.ObjectPropertyExt("data", "Data")
        .addStateImplementation("default", ProjectAppTranslations);
    public data: ProjectAppTranslations;

    private additionalMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.nameMetadata.IsReadOnly = true;
        this.additionalMetadata = [this.nameMetadata, this.dataMetadata];
        //this.dataMetadata.RenderInline = true;
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.additionalMetadata;
    }
}

class ProjectAppTranslations extends propertyTypes.Serializable {
    private Standard_Msg_LoeschenMetadata = new propertyTypes.TranslatableTextProperty("Standard.Msg.Loeschen", "Standard.Msg.Loeschen");
    private WebSMS_Project_AddAssignedMachines = new propertyTypes.TranslatableTextProperty("WebSMS.Project.AddAssignedMachines", "WebSMS.Project.AddAssignedMachines");
    private WebSMS_Project_DeleteAssignedMachines = new propertyTypes.TranslatableTextProperty("WebSMS.Project.DeleteAssignedMachines", "WebSMS.Project.DeleteAssignedMachines");
    private Projekt_AddressContactPersons = new propertyTypes.TranslatableTextProperty("Projekt.AddressContactPersons", "Projekt.AddressContactPersons");
    private Projekt_ProjectContactPersons = new propertyTypes.TranslatableTextProperty("Projekt.ProjectContactPersons", "Projekt.ProjectContactPersons");
    private Standard_Neu = new propertyTypes.TranslatableTextProperty("Standard.Neu", "Standard.Neu");
    private Standard_Editieren = new propertyTypes.TranslatableTextProperty("Standard.Editieren", "Standard.Editieren");
    private Standard_Loeschen = new propertyTypes.TranslatableTextProperty("Standard.Loeschen", "Standard.Loeschen");
    private Standard_Add = new propertyTypes.TranslatableTextProperty("Standard.Add", "Standard.Add");
    private WebSMS_Project_Machine = new propertyTypes.TranslatableTextProperty("WebSMS.Project.Machine", "WebSMS.Project.Machine");
    private Maschine_Maschinensuche = new propertyTypes.TranslatableTextProperty("Maschine.Maschinensuche", "Maschine.Maschinensuche");
    private Ansprechpartner_Ansprechpartner = new propertyTypes.TranslatableTextProperty("Ansprechpartner.Ansprechpartner", "Ansprechpartner.Ansprechpartner");
    private Projekt_Material = new propertyTypes.TranslatableTextProperty("Projekt.Material", "Projekt.Material");
    private WebSMS_Title_ContactEditing = new propertyTypes.TranslatableTextProperty("WebSMS.Title.ContactEditing", "WebSMS.Title.ContactEditing");
    private WebSMS_Project_UngültigeDebitoradresse = new propertyTypes.TranslatableTextProperty("WebSMS.Project.UngültigeDebitoradresse", "WebSMS.Project.UngültigeDebitoradresse");
    private Einsatz_ArtikelZumEinsatz = new propertyTypes.TranslatableTextProperty("Einsatz.ArtikelZumEinsatz", "Einsatz.ArtikelZumEinsatz");
    private Einsatz_Balkeninfo = new propertyTypes.TranslatableTextProperty("Einsatz.Balkeninfo", "Einsatz.Balkeninfo");
    private Projekt_MappedToAssigment = new propertyTypes.TranslatableTextProperty("Projekt.MappedToAssigment", "Projekt.MappedToAssigment");
    private Projekt_OpenAssigment = new propertyTypes.TranslatableTextProperty("Projekt.OpenAssigment", "Projekt.OpenAssigment");

    private allTranslationsMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.allTranslationsMetadata = [this.Standard_Msg_LoeschenMetadata, this.WebSMS_Project_AddAssignedMachines, this.WebSMS_Project_DeleteAssignedMachines,
        this.Projekt_AddressContactPersons, this.Projekt_ProjectContactPersons, this.Standard_Neu, this.Standard_Editieren, this.Standard_Loeschen, this.Standard_Add, this.WebSMS_Project_Machine,
        this.Maschine_Maschinensuche, this.Ansprechpartner_Ansprechpartner, this.Projekt_Material, this.WebSMS_Title_ContactEditing, this.WebSMS_Project_UngültigeDebitoradresse, this.Einsatz_ArtikelZumEinsatz, this.Einsatz_Balkeninfo, this.Projekt_MappedToAssigment, this.Projekt_OpenAssigment
        ];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.allTranslationsMetadata;
    }
}

class DataOpeningHoursSchema extends propertyTypes.Serializable {
    private dataMetadata = new propertyTypes.NotEditableProperty("data", "Data");
    public data: string;

    private additionalMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.additionalMetadata = [this.dataMetadata];
        //this.dataMetadata.RenderInline = true;
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.additionalMetadata;
    }
}